import { Publication } from './publication';

export class LicenceKey {

    
    id : number;
    create_by;
    date_create: string;
    num: string;
    activated: boolean;
    hwidDevices: string[];
    user;
    nbr_activation: number;
    nbr_jour: number;
    nbr_data_base;
    
    constructor() {
        // super();
        this.activated = false;
        this.nbr_jour = 1;
        this.nbr_data_base = 1;
    }

    
    
   
  }